import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { Divider } from './botanical/Divider';
const faqs = [{
  q: '¿Necesito saber de plantas o medicina natural?',
  a: 'No. Está escrito para personas sin ningún conocimiento previo. Si podés preparar una infusión, podés usar este sistema.'
}, {
  q: '¿Los ingredientes se consiguen en Argentina?',
  a: 'Sí. Todo está pensado para conseguirse en el súper, el almacén o la dietética del barrio. Sin importaciones ni productos caros.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Es 100% digital. Apenas completás la compra recibís acceso inmediato a todos los PDF. Lo abrís en el celular, tablet o computadora.'
}, {
  q: '¿Sirve si vivo solo o sola?',
  a: 'Absolutamente. De hecho uno de los perfiles más beneficiados es quien vive solo porque ahora tiene un sistema de respuesta propio sin depender de nadie.'
}, {
  q: '¿Reemplaza al médico?',
  a: 'No. Este sistema es educativo y complementario. Para emergencias médicas reales siempre consultá a un profesional de la salud.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si no te gusta te devolvemos el 100% sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-forest-mist" data-id="element-229">
      <div className="max-w-3xl mx-auto" data-id="element-230">
        <div className="text-center mb-12" data-id="element-231">
          <div className="inline-flex items-center justify-center gap-2 text-forest-deep font-bold tracking-widest uppercase mb-4" data-id="element-232">
            <HelpCircle className="w-5 h-5 text-moss" data-id="element-233" />
            LO QUE MÁS NOS PREGUNTAN
          </div>
        </div>

        <div className="space-y-4" data-id="element-234">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-white/90 backdrop-blur-sm rounded-xl border transition-colors ${isOpen ? 'border-moss shadow-sm' : 'border-sage-mist hover:border-moss/50'}`} data-id="element-235">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : idx)} aria-expanded={isOpen} data-id="element-236">
                  <span className="font-serif font-bold text-forest-deep text-lg pr-8" data-id="element-237">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-moss shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-238" />
                </button>
                <AnimatePresence initial={false} data-id="element-239">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-240">
                      <div className="px-6 pb-5 pt-0 text-forest/80 leading-relaxed" data-id="element-241">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
      <Divider className="mt-16" data-id="element-242" />
    </Section>;
}